import { render, staticRenderFns } from "./myPurchase.vue?vue&type=template&id=2327aa66&scoped=true"
import script from "./myPurchase.vue?vue&type=script&lang=js"
export * from "./myPurchase.vue?vue&type=script&lang=js"
import style0 from "./myPurchase.vue?vue&type=style&index=0&id=2327aa66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327aa66",
  null
  
)

export default component.exports